function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Componente_9_39",
  "data-name": "Componente 9 \\u2013 39",
  transform: "translate(0 25.145) rotate(-90)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Pol\\xEDgono_26",
  "data-name": "Pol\\xEDgono 26",
  d: "M11.694,0,23.389,11.051H0Z",
  transform: "translate(25.145) rotate(90)",
  fill: "#93d0a9"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Ret\\xE2ngulo_25",
  "data-name": "Ret\\xE2ngulo 25",
  width: 14.413,
  height: 7.206,
  transform: "translate(0 7.893)",
  fill: "#93d0a9"
}));

var SvgPositivoDash = function SvgPositivoDash(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17.389,
    height: 19.145,
    viewBox: "0 0 23.389 25.145",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPositivoDash, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/PositivoDash.3903de84.svg";
export { ForwardRef as ReactComponent };